import { Input } from '@apia/theme';
import { observer } from 'mobx-react-lite';
import { TFilterRenderer } from './types';
import { useResponsiveTableContext } from '@apia/table';
import { getLabel, TApiaFilter } from '@apia/util';
import FilterLabel from '../FilterLabel';
import { ApiaUtil } from '@apia/components';

const numericFilterTypes = ['N', 'number', 'apiaNumber'];

export const InputFilterRenderer: TFilterRenderer = observer(({ state }) => {
  const { onFilterBlur, onFilterPressEnter } = useResponsiveTableContext();
  const validateNumericValue = () => {
    if (
      !numericFilterTypes.includes(state.type ?? '') ||
      state.value === '' ||
      state.value === null ||
      state.value === undefined
    ) {
      return true;
    }

    const value = String(state.value);
    const parsedValue = /\d/.test(value)
      ? ApiaUtil.instance.parsers.apiaNumber(value)
      : '';

    if (parsedValue) {
      state.value = state.showAsInteger
        ? String(Math.trunc(ApiaUtil.instance.parsers.jsNumber(parsedValue)))
        : parsedValue;
      return true;
    }

    state.value = '';
    ApiaUtil.instance.notifications.notify({
      message: getLabel('msgMustBeNum').text,
      type: 'warning',
    });
    return false;
  };

  return (
    <>
      <FilterLabel state={state} isDate />
      <Input
        className="filter__query"
        data-query-filter-id={state.id}
        data-query-filter-part="value"
        sx={{
          '&.filter__query.filter__query:not([disabled])': {
            borderLeft: state.required ? '4px solid' : undefined,
            borderLeftColor: state.required ? 'palette.error.main' : undefined,
          },
        }}
        disabled={state.readonly}
        value={state.value}
        onChange={(ev) => {
          state.value = ev.target.value;
        }}
        onKeyDown={(ev) => {
          if (ev.code === 'Enter' && validateNumericValue()) {
            onFilterPressEnter?.(state as any as TApiaFilter);
          }
        }}
        onBlur={() => {
          if (validateNumericValue()) {
            onFilterBlur?.(state as any as TApiaFilter);
          }
        }}
      />
    </>
  );
});
